class Extract_Relation {
    static path = 'variables/extract-relation';

    constructor(mutator){
        this.addInput("Source", "model");
        this.addOutput("", "nooutput");
        this.bgcolor = '#f5967d';
        this.title = 'Extract Relation';
        this.desc = 'Extract related data node from a data node';
        this.properties = {selected: '', options: [], modelProperties: {}, parentProperties: {}, xTypes: {}};

    }

    onConnectionsChange(type) {
        if(type === 1) { //LiteGraph.INPUT
            let relations
            if(window.settingUpGraph) {
                relations = this.properties.parentProperties.relations;
                this.properties.options = [];
                this.properties.xTypes = {};
            } else {
                this.widgets = [];
                this.properties.modelProperties = {};
                this.properties.parentProperties = {};
                this.properties.options = [];
                this.properties.xTypes = {};
                let parent_node = this.getParentNode();
                if (!parent_node) {
                    this.title = 'Extract Relation'
                    this.outputs[0].name = '';
                    this.outputs[0].type = 'nooutput';
                    this.disconnectOutput(0);
                    return;
                }
                relations = parent_node.properties.modelProperties && parent_node.properties.modelProperties.relations && Object.keys(parent_node.properties.modelProperties.relations).length > 0 ? parent_node.properties.modelProperties.relations : false;
                this.properties.parentProperties = parent_node.properties.modelProperties;
            }

            if (relations) {
                Object.keys(relations).forEach((rel) => {
                    this.properties.options.push(relations[rel].title);
                    this.properties.xTypes[relations[rel].title] = {
                        'model': relations[rel].model,
                        'quantity': relations[rel].quantity,
                        'relation': rel
                    };
                });
            } else {
                this.title = 'Extract Relation'
                this.outputs[0].name = '';
                this.outputs[0].type = 'nooutput';
                this.disconnectOutput(0);
                return;
            }

            this.setupPropertySelectionWidget();
        }

    }
    setupPropertySelectionWidget() {
        this.addWidget("combo","",this.properties.selected,(v) => {
            this.properties.selected = v;
            if(v !== '' && this.properties.xTypes[v]) {
                this.title = (v + ' ('+(this.properties.xTypes[v] && this.properties.xTypes[v].quantity ? this.properties.xTypes[v].quantity : '?')+')') || 'Extract Relation';
                this.outputs[0].name = this.properties.xTypes[v].model === 'user' ? v+' (user)' : v;
                this.outputs[0].type = this.properties.xTypes[v].model === 'user' ? 'model,user' : 'model';
                this.properties.modelProperties = window.triggerInfo.models[this.properties.xTypes[v].model];
                this.disconnectOutput(0);
            } else {
                this.title = 'Extract Relation'
                this.outputs[0].name = '';
                this.outputs[0].type = 'nooutput';
                this.properties.modelProperties = {};
                this.disconnectOutput(0);
            }

            this.triggerSlot(0, v);
        },{ property: "selected", values: this.properties.options } );
    }
}

module.exports = Extract_Relation
